export const isTrue = (value: any) => {
  return [true, 1, 'true', 'enabled', 'yes'].indexOf(value) > -1;
}